import * as React from 'react'
import { Props } from './SearchResults'
import { SearchResultsList } from './SearchResultsList/SearchResultsList'
import { Pending } from '../Pending'
import { Fail } from '../Fail'
import { NoResults } from '../NoResults/NoResults'

export function SearchResultsContent(props: Props) {
  const { searchStatus, searchData, searchText, recentSearchData } = props

  switch (searchStatus) {
    case 'idle':
      if (recentSearchData.length > 0) {
        return (
          <SearchResultsList
            onLocationClick={props.onLocationClick}
            onRowClick={props.onRowClick}
            searchList={recentSearchData}
            searchText={searchText}
            onSearchAddressClick={props.onSearchAddressClick}
            recent
          />
        )
      }
      return null
    case 'pending':
      return <Pending />
    case 'fail':
      return <Fail />
    case 'success':
      if (searchData) {
        if (searchData.count === 0) {
          return <NoResults />
        } else {
          return (
            <SearchResultsList
              onLocationClick={props.onLocationClick}
              onRowClick={props.onRowClick}
              searchList={searchData.searchList}
              searchText={searchText}
              onSearchAddressClick={props.onSearchAddressClick}
            />
          )
        }
      } else {
        return null
      }
  }
}
